import HCaptcha from '@hcaptcha/react-hcaptcha';

export interface CaptchaProps {
  onSuccess: (token: string) => void;
}

const Captcha = ({ onSuccess }: CaptchaProps) => {
  return <HCaptcha
    sitekey="6abccafe-dac4-46c8-934e-84504cbe1f86"
    onVerify={onSuccess}
  />;
};

export default Captcha;
